module.exports = __webpack_public_path__ + "img/comment.93b9ae6c.svg";